export default {
  //Used local storage keys
  LAST_USED_PRINTER_TYPE_KEY: 'lptid',
  PRINTER_TYPE_BY_FILE_KEY: 'ptbf',
  SLICER_BY_PRINTER_TYPE_KEY: 'stbpt',
  SLICER_BY_FILE_KEY: 'stbf',
  COLOR_KEY: 'color',
  HIDE_CHROME_WARNING: 'hchrome',
  LOCALE_KEY: 'locale',

  //Local storage methods
  getValue(key, decodeJson = false, defaultValue = undefined) {
    let data = window.localStorage.getItem(key);
    if (!data) {
      return defaultValue;
    }

    return decodeJson ? JSON.parse(data) : data;
  },

  setValue(key, data, encodeJson = false) {
    window.localStorage.setItem(key, encodeJson ? JSON.stringify(data) : data);
  },

  hasValue(key) {
    return window.localStorage.getItem(key) !== null;
  },

  updateJsonKeyValue(storageKey, key, value) {
    const data = this.getValue(storageKey, true, {});
    data[key] = value;
    this.setValue(storageKey, data, true);
  }
}
